import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type {
  IExtendedTableDataResponse,
  ITableState,
} from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type {
  IAffiliateTrackersAdditionalTableData,
  IAffiliateTrackersListItem,
} from '../types';
import {
  AFFILIATE_TRACKERS_LIST_API_URL,
  AFFILIATE_TRACKERS_LIST_QUERY_KEY,
  AFFILIATE_TRACKERS_PERMISSIONS,
} from '../constants';

export default function useAffiliateTrackersListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<IExtendedTableDataResponse<IAffiliateTrackersListItem, IAffiliateTrackersAdditionalTableData>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<IExtendedTableDataResponse<IAffiliateTrackersListItem, IAffiliateTrackersAdditionalTableData>>({
    queryKey: [AFFILIATE_TRACKERS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<IExtendedTableDataResponse<IAffiliateTrackersListItem, IAffiliateTrackersAdditionalTableData>>(
      AFFILIATE_TRACKERS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
